"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AjvError () {
        return _ncError.AjvError;
    },
    get BadRequest () {
        return _nocodbsdk.BadRequestV2;
    },
    get ExternalError () {
        return _nocodbsdk.ExternalError;
    },
    get ExternalTimeout () {
        return _nocodbsdk.ExternalTimeout;
    },
    get Forbidden () {
        return _nocodbsdk.Forbidden;
    },
    get MetaError () {
        return _nocodbsdk.MetaError;
    },
    get NcBaseError () {
        return _nocodbsdk.NcBaseError;
    },
    get NcBaseErrorv2 () {
        return _nocodbsdk.NcBaseErrorv2;
    },
    get NcError () {
        return _ncError.NcError;
    },
    get NcErrorArgs () {
        return _nocodbsdk.NcErrorArgs;
    },
    get NotFound () {
        return _nocodbsdk.NotFound;
    },
    get OptionsNotExistsError () {
        return _nocodbsdk.OptionsNotExistsError;
    },
    get SsoError () {
        return _nocodbsdk.SsoError;
    },
    get TestConnectionError () {
        return _nocodbsdk.TestConnectionError;
    },
    get Unauthorized () {
        return _nocodbsdk.Unauthorized;
    },
    get UniqueConstraintViolationError () {
        return _nocodbsdk.UniqueConstraintViolationError;
    },
    get UnprocessableEntity () {
        return _nocodbsdk.UnprocessableEntity;
    },
    get extractDBError () {
        return extractDBError;
    }
});
const _extractor = require("./db-error/extractor");
const _nocodbsdk = require("nocodb-sdk");
const _ncError = require("~/helpers/ncError");
function extractDBError(error, context) {
    return _extractor.DBErrorExtractor.get().extractDbError(error, context);
}
